import { render } from "./PersonnelSystem.vue?vue&type=template&id=2ffcc35e"
import script from "./PersonnelSystem.vue?vue&type=script&lang=js"
export * from "./PersonnelSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__